import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconCommentOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M3 24v-6.152A10.47 10.47 0 0 1 0 10.5C0 4.701 4.701 0 10.5 0h3C19.299 0 24 4.701 24 10.5S19.299 21 13.5 21h-3c-.789 0-1.558-.087-2.297-.252zm1.5-2.706 3.43-2.144.6.134q.963.215 1.97.216h3a9 9 0 1 0 0-18h-3a9 9 0 0 0-9 9c0 2.389.933 4.626 2.571 6.299l.429.437z" /></svg>
);
